module.exports = __webpack_public_path__ + "assets/img/bcaa4f9943ad02517b46bb7e5d726837.jpg";